import { render } from "./DeleteAction.vue?vue&type=template&id=257e068b"
import script from "./DeleteAction.vue?vue&type=script&lang=js"
export * from "./DeleteAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__